import { render, staticRenderFns } from "./UnsavedDatapopup.vue?vue&type=template&id=6d5ea412&scoped=true&"
import script from "./UnsavedDatapopup.vue?vue&type=script&lang=js&"
export * from "./UnsavedDatapopup.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedDatapopup.vue?vue&type=style&index=0&id=6d5ea412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ea412",
  null
  
)

export default component.exports